import { Portal, Stack, type Theme, useMediaQuery } from "@mui/material";
import { useResponsiveButtons } from "./context";
import { ButtonBox, classes } from "./style";

export const ResponsiveFloatingButtons = () => {
  const { buttons, breakpoint } = useResponsiveButtons();
  const breakpointReached = useMediaQuery((theme: Theme) => theme.breakpoints.up(breakpoint));
  return (
    <>
      {!breakpointReached && buttons.length > 0 && (
        <Portal>
          <Stack
            direction="row"
            sx={{
              gap: 1,
              alignItems: "center",
              position: "fixed",
              bottom: 16,
              right: 16,
            }}
          >
            {buttons.map(({ button, id }) => (
              <ButtonBox className={classes.root} key={id} display="flex" alignItems="center" justifyContent="center">
                {button}
              </ButtonBox>
            ))}
          </Stack>
        </Portal>
      )}
    </>
  );
};
